import { create } from 'zustand';
import { WfPaginatedWorkplace, WfWorkplace } from '../models/WfWorkplace';
import { WfDataSummary } from '../models/WfDataSummary';
import { persist, createJSONStorage } from 'zustand/middleware';
import { sharedStorage } from 'src/common/storage/storage';

interface WfWorkplaceStore {
  availableWorkplaces: WfWorkplace[];
  paginatedWorkplace: WfPaginatedWorkplace | null;
  selectedWorkplace: WfWorkplace | null;
  workplaceSummary: WfDataSummary[];
  setAvailableWorkplaces: (availableWorkplaces: WfWorkplace[]) => void;
  setPaginatedWorkplace: (paginatedWorkplace: WfPaginatedWorkplace | null) => void;
  setSelectedWorkplace: (selectedWorkplace: WfWorkplace | null) => void;
  setWorkplaceSummary: (workplaceSummary: WfDataSummary[]) => void;
}

export const useWfWorkplaceStore = create<WfWorkplaceStore>()(
  persist<WfWorkplaceStore>(
    (set) => ({
      availableWorkplaces: [],
      paginatedWorkplace: null,
      selectedWorkplace: null,
      workplaceSummary: [],
      setAvailableWorkplaces: (availableWorkplaces: WfWorkplace[]) => set({ availableWorkplaces }),
      setPaginatedWorkplace: (paginatedWorkplace: WfPaginatedWorkplace | null) =>
        set({ paginatedWorkplace }),
      setSelectedWorkplace: (selectedWorkplace: WfWorkplace | null) => set({ selectedWorkplace }),
      setWorkplaceSummary: (workplaceSummary: WfDataSummary[]) => set({ workplaceSummary }),
    }),
    {
      name: 'wf-workplace',
      storage: createJSONStorage(() => sharedStorage),
      partialize: (state) =>
        ({
          selectedWorkplace: state.selectedWorkplace,
          workplaceSummary: state.workplaceSummary,
        }) as WfWorkplaceStore,
    }
  )
);
